import { Timestamp } from 'firebase/firestore'

import { UserModelFactory } from 'monocle-models'

const { UserDBModel } = new UserModelFactory(Timestamp)

import { z } from 'zod'

export default function () {
  // Utility functions for checking quota status of any user
  const isUserOverQuota = (user: z.infer<typeof UserDBModel>) => {
    if (!user) return false
    return UserModelFactory.isOverQuota(user)
  }

  const isUserNearQuota = (user: z.infer<typeof UserDBModel>) => {
    if (!user) return false
    return UserModelFactory.isNearQuota(user)
  }

  const storageQuota = (user: z.infer<typeof UserDBModel>) => {
    return user.storage_quota
  }

  return {
    isUserNearQuota,
    isUserOverQuota,
    storageQuota,
  }
}
